import ReaderModeViewer from './ReaderModeViewer';

export default ReaderModeViewer;
